import { Trophy } from "lucide-react";
import { useSelector } from "react-redux";
import Card from "../card";
import * as S from "../dashboard/_shared";
import Section from "../section";
import Tag from "../tag";
import { classifyPos, classifyAbs, fmtVar, transformarBenchmarks } from "./dataTransforms";
import "./style.scss";

export default function BenchmarkingView({ ctx }) {
  const benchmarkingState = useSelector(
    (state) => state.dashboard.benchmarking,
  );
  const benchmarkingData = benchmarkingState?.data?.data || [];

  const { C, ESCALA } = S;
  const { per } = ctx;

  return (() => {
    const rows = transformarBenchmarks(benchmarkingData);

    return (
      <div
        className="tabBenchmarkingView"
        style={{ display: "flex", flexDirection: "column", gap: 14 }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              fontSize: 15,
              fontWeight: 700,
              color: C.text,
              letterSpacing: "-0.02em",
            }}
          >
            Benchmarking Sistema Unimed
          </div>
        </div>
        <Card
          style={{
            padding: "14px 18px",
            background: C.g800,
            border: "none",
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <Trophy size={22} color={C.g300} />
          <div>
            <div style={{ color: "#FFFFFF", fontWeight: 600, fontSize: 14 }}>
              Benchmarking Sistema Unimed — {per.label}
            </div>
            <div style={{ color: "rgba(255,255,255,.45)", fontSize: 11 }}>
              Base: cooperativas Unimed · dados anonimizados
            </div>
          </div>
        </Card>
        <Section title="Sua posição vs. Sistema Unimed" pad={false}>
          <div style={{ padding: "0 20px 18px", overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: 13,
              }}
            >
              <thead>
                <tr>
                  {[
                    { h: "Indicador", align: "left" },
                    { h: "Você", align: "center" },
                    { h: "Classificação", align: "center" },
                    { h: "Média Sistema Unimed", align: "center" },
                    { h: "Concorrência Nacional", align: "center" },
                    { h: "Variação vs Unimed", align: "center" },
                    { h: "Posição", align: "center" },
                  ].map(({ h, align }) => (
                    <th
                      key={h}
                      style={{
                        padding: "10px 12px",
                        textAlign: align,
                        background: C.g800,
                        color:
                          h === "Você"
                            ? C.g300
                            : h === "Concorrência Nacional"
                              ? "#FBBF24"
                              : "#FFFFFF",
                        fontSize: 11,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.06em",
                        borderBottom: `2px solid ${C.g600}`,
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => {
                  const pos = classifyPos(row.vc, row.med);
                  const abs = classifyAbs(row.tipo, row.vc);
                  const vr = fmtVar(row.tipo, row.vc, row.med);
                  const vrConc = fmtVar(row.tipo, row.vc, row.conc);
                  const isHl = row.destaque;
                  const tipoColor =
                    row.tipo === "NPS"
                      ? C.g700
                      : row.tipo === "CES"
                        ? C.blue
                        : row.tipo === "JCX"
                          ? "#d97706"
                          : C.g600;
                  const tipoBg =
                    row.tipo === "NPS"
                      ? C.g100
                      : row.tipo === "CES"
                        ? C.blueBg
                        : row.tipo === "JCX"
                          ? "#FFFBEB"
                          : C.greenBg;
                  const cellPad = isHl ? "14px 12px" : "11px 12px";
                  return (
                    <tr
                      key={i}
                      style={{
                        background: isHl
                          ? C.g100
                          : i % 2 === 0
                            ? C.surface
                            : C.surf3,
                        borderBottom: `1px solid ${C.border}`,
                        borderTop:
                          isHl && i === 0
                            ? "none"
                            : isHl
                              ? `2px solid ${C.g300}`
                              : "none",
                      }}
                    >
                      <td
                        style={{
                          padding: cellPad,
                          fontWeight: isHl ? 700 : 500,
                          color: C.text,
                          fontSize: isHl ? 14 : 13,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <Tag label={row.tipo} color={tipoColor} bg={tipoBg} />
                          {row.k}
                        </div>
                      </td>
                      <td
                        style={{
                          padding: cellPad,
                          textAlign: "center",
                          fontWeight: 700,
                          fontSize: isHl ? 20 : 16,
                          color: tipoColor,
                          letterSpacing: "-0.03em",
                        }}
                      >
                        {row.tipo === "NPS" ? row.vc : `${row.vc}%`}
                      </td>
                      <td style={{ padding: cellPad, textAlign: "center" }}>
                        <Tag
                          label={abs.label}
                          color={abs.color}
                          bg={abs.bg}
                          size={isHl ? "md" : "sm"}
                        />
                      </td>
                      <td
                        style={{
                          padding: cellPad,
                          textAlign: "center",
                          color: C.text3,
                          fontSize: isHl ? 15 : 13,
                          fontWeight: isHl ? 600 : 400,
                        }}
                      >
                        {row.tipo === "NPS" ? row.med : `${row.med}%`}
                      </td>
                      <td style={{ padding: cellPad, textAlign: "center" }}>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          <div
                            style={{
                              color: "#B45309",
                              fontSize: isHl ? 15 : 13,
                              fontWeight: isHl ? 700 : 600,
                            }}
                          >
                            {row.tipo === "NPS" ? row.conc : `${row.conc}%`}
                          </div>
                          <div
                            style={{
                              fontSize: 9,
                              fontWeight: 700,
                              color: vrConc.color,
                              background: vrConc.color + "15",
                              padding: "1px 6px",
                              borderRadius: 20,
                            }}
                          >
                            {vrConc.text} vs mercado
                          </div>
                        </div>
                      </td>
                      <td
                        style={{
                          padding: cellPad,
                          textAlign: "center",
                          fontWeight: 700,
                          fontSize: isHl ? 15 : 13,
                          color: vr.color,
                          letterSpacing: "-0.02em",
                        }}
                      >
                        {vr.text}
                      </td>
                      <td style={{ padding: cellPad, textAlign: "center" }}>
                        <Tag
                          label={pos.label}
                          color={pos.color}
                          bg={pos.bg}
                          size={isHl ? "md" : "sm"}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </Section>
      </div>
    );
  })();
}
